import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { IsUUID } from 'class-validator';
import { JobOrderItemInterface } from '../interfaces/job-order-item.interface';
import { BuilderDto } from '../../builder/dto/builder.dto';
import { SpOrderDto } from '../../sp/order/dtos/sp-order.dto';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';

@Exclude()
export class JobOrderItemDto
  extends CommonEntityDto
  implements JobOrderItemInterface
{
  @ApiProperty({
    title: 'SP Order ID',
    type: 'uuid',
  })
  @IsUUID()
  @Expose()
  spOrderId!: string;

  @ApiProperty({
    title: 'Item description ID',
    type: 'uuid',
  })
  @IsUUID()
  @Expose()
  itemDescriptionId!: string;

  @ApiProperty({ title: 'Order Item Description', type: 'string' })
  @Expose()
  itemDescription!: string;

  @ApiProperty({ title: 'Board type name', type: 'string' })
  @Expose()
  boardTypeName!: string;

  @ApiProperty({ title: 'Board type short name', type: 'string' })
  @Expose()
  boardTypeShortname!: string;

  @ApiProperty({
    type: 'boolean',
    title: 'Sp builder board type is active?',
    nullable: true,
  })
  @Expose()
  active!: boolean | null;

  @ApiProperty({
    type: 'boolean',
    title: 'Sp builder board type is already mapped?',
  })
  @Expose()
  hasMatch!: boolean;

  @ApiProperty({
    title: 'Builder Id',
    nullable: true,
  })
  @Expose()
  builderId!: string;

  @ApiPropertyOptional({
    type: () => [BuilderDto],
    title: 'Builder',
    description: 'The builder associated with this job order item',
  })
  @Expose()
  builder!: BuilderDto;

  @ApiPropertyOptional({
    type: () => [SpOrderDto],
    title: 'Builder',
    description: 'The sp order associated with this job order item',
  })
  @Expose()
  spOrder!: SpOrderDto;
}
